import { INTEGRATION_PROVIDERS, type IntegrationProviders } from '@vy/types';
import { isNullOrUndefined } from '@vy/utils';

export const INTEGRATION_COLUMN_PROVIDERS: Record<string, IntegrationProviders> = {
  nsErpId: INTEGRATION_PROVIDERS.netSuite,
  qbErpId: INTEGRATION_PROVIDERS.quickBooks,
  xeroErpId: INTEGRATION_PROVIDERS.xero,
  stripeId: INTEGRATION_PROVIDERS.stripe,
  netSuiteSalesOrderId: INTEGRATION_PROVIDERS.netSuite,
  salesforceOpportunityId: INTEGRATION_PROVIDERS.salesforce,
};

export function isColumnVisibleForConnectedIntegrations(
  field: string,
  connectedProviders: ReadonlySet<IntegrationProviders>,
): boolean {
  const provider = INTEGRATION_COLUMN_PROVIDERS[field];

  if (isNullOrUndefined(provider)) {
    return true;
  }

  return connectedProviders.has(provider);
}
